'use strict';

var App = App || {};

// REMOVE THE MULTIPLE FLIP THING
App.BioCards = function () {
  'use strict';

  var $bioCard = $('.bio-card'),
      cardAnimationSpeed = 350,
      rotationState = 0,

  // This counts the prev/next clicks to determine if the content should be flipped.
  bioCardTraversalCount = 0;

  var initialize = function initialize() {
    _bindClickToggleOverlay();
    _bindDocumentCloseClick();
  };

  var _bindClickToggleOverlay = function _bindClickToggleOverlay() {
    $(document).on('click', '.js-toggle-bio-overlay', function (e) {
      e.preventDefault();

      if ($('body').hasClass('bio-overlay-active')) {
        _hideOverlay();
      } else {
        var selectedBioId = $(this).attr("data-bio-id");
        // Get id of selected bio pass it to the show overlay people.
        _showOverlay(selectedBioId);
      }
    });
  };

  var _bindDocumentCloseClick = function _bindDocumentCloseClick() {
    // Set a document click to close nav.
    $(document).on('click', window, function () {
      if ($('.overlay-bio').is(':visible')) _hideOverlay();
    });

    // Prevent in-nav click propagation to document
    $(document).on('click', '.bio-card', function (e) {
      e.stopPropagation();
    });
  };

  var _showOverlay = function _showOverlay(selectedBioId) {
    var $targetBio = $('#' + selectedBioId);

    // Set this initially via Velocity. Setting it via CSS prevents it from "sticking" on completion.
    $bioCard.velocity({
      rotateY: 0
    }, {
      delay: 0,
      duration: 0
    });

    // Clear any selected cards without screwing up the closing animation
    $('.card-face').removeClass('selected');
    $targetBio.addClass('selected');

    $('body').addClass('bio-overlay-active');
    $('.overlay-bio').velocity('fadeIn', 'fast');

    $bioCard.velocity({
      rotateY: [0, 90]
    }, {
      delay: 0,
      duration: cardAnimationSpeed
    });
  };

  var _hideOverlay = function _hideOverlay() {
    function onComplete() {
      rotationState = 0;
      $('.card-face').removeClass('selected').removeClass('front');
    }

    $bioCard.velocity({
      rotateY: rotationState + 90
    }, {
      delay: 0,
      duration: cardAnimationSpeed,
      complete: onComplete
    });
    // Overflow auto on Body
    $('.overlay-bio').velocity('fadeOut', { delay: cardAnimationSpeed - 200 });
    $('body').removeClass('bio-overlay-active');
  };

  return {
    initialize: initialize
  };
}();